import initializeLogin from "components/login";
import general from "general";
import cookies from "general/cookies";
import constants from "general/constants";
import localSession from "general/localSession";

$(document).ready(function() {
  const [getUser, setUser] = localSession.user;
  let redirectUrl = $("#redirect-url").data("url") || "/",
    redirect = function() {
      const user = getUser();
      if (user) {
        if (
          user.user_data.find((e) => (
            e.key === "calendar_view"
            & e.value === "timeslot"
          ))
        ) {
          redirectUrl = "/account/timeslot-scheduler/";
        } else {
          if (!redirectUrl || redirectUrl == "/") {
            redirectUrl = "/account/appointments/";
          }
        }
      }

      if (redirectUrl[0] != "/") {
        redirectUrl = "/" + redirectUrl;
      }

      window.location.pathname = redirectUrl;
    },
    authorized = function() {
      cookies.set("authorised", true, constants.sessionAgeInDays);
      redirect();
    },
    unauthorized = function() {
      $(".sign-in__message--unauthorized").removeClass("hide");
    },
    serverError = function() {
      $(".sign-in__message--server-error").removeClass("hide");
    },
    callbacks = {
      201: authorized,
      401: [unauthorized],
      503: serverError,
    },
    container = initializeLogin(
      ".sign-in__form",
      callbacks,
      false,
      true
    ),
    isLoggedIn = document.querySelector("#is-logged-in"),
    apiTokenChain = $("#api-token-chain").data("api-token-chain"),
    emailInput = container.find("#login-email-input"),
    passwordInput = container.find("#login-email-input"),
    tmpEmail = general.storage.getItem("tmp_email");

  if (apiTokenChain) {
    general.startSessionWithToken(apiTokenChain, callbacks);
  } else if (isLoggedIn.dataset.value === "true") {
    general.callBFF("/session/", "GET")
      .then((response) => {
        setUser(response);
      })
      .then(authorized);
  } else {
    if (tmpEmail) {
      emailInput.val(tmpEmail);
      passwordInput.focus();
    } else {
      emailInput.focus();
    }
  }
});
